export default "__VITE_PUBLIC_ASSET__432acea8__"